function displayCount(value, loading) {
  return loading ? "—" : Number(value || 0).toLocaleString();
}

export function InventoryMetricCards({ inventory = {}, loading = false }) {
  return (
    <div className="cg-history-metrics" aria-busy={loading}>
      <article className="cg-metric-card">
        <span>Total inventory</span>
        <strong>{displayCount(inventory.total_codes, loading)}</strong>
        <small>All generated codes currently stored</small>
      </article>
      <article className="cg-metric-card">
        <span>Available</span>
        <strong>{displayCount(inventory.available_codes, loading)}</strong>
        <small>Ready to be assigned</small>
      </article>
      <article className="cg-metric-card">
        <span>Requested</span>
        <strong>{displayCount(inventory.requested_codes, loading)}</strong>
        <small>Currently pending completion</small>
      </article>
      <article className="cg-metric-card">
        <span>Released</span>
        <strong>{displayCount(inventory.released_codes, loading)}</strong>
        <small>Completed code activity</small>
      </article>
    </div>
  );
}

export function ActivityMetricCards({ activity = {}, loading = false }) {
  const totals = activity.totals || {};
  return (
    <div className="cg-history-metrics cg-metrics-three" aria-busy={loading}>
      <article className="cg-metric-card cg-metric-card-light">
        <span>Code requests</span>
        <strong>{displayCount(totals.requests_started, loading)}</strong>
        <small>Started during the last 7 days</small>
      </article>
      <article className="cg-metric-card cg-metric-card-light">
        <span>Code releases</span>
        <strong>{displayCount(totals.releases_completed, loading)}</strong>
        <small>Completed during the last 7 days</small>
      </article>
      <article className="cg-metric-card cg-metric-card-light">
        <span>Orders attached</span>
        <strong>{displayCount(totals.orders_attached, loading)}</strong>
        <small>Linked during the last 7 days</small>
      </article>
    </div>
  );
}
